import { createAction, props } from "@ngrx/store";
export const setGenericDocTaxListing_State = createAction(
  "[Column 1 View Model] Set Generic Doc Tax Listing State",
  props<{ genericDocTaxListingState: any }>()
);